import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import RenderWithPermission from '~/containers/renderWithPermission/renderWithPermission';
import BreweryEdit from '~/containers/breweryEdit/breweryEdit';
import { permissions } from '../../utils/permissions';

export class BrewerySettingsPage extends Component {
  render() {
    const { brewery } = this.props;

    const cancelButton = (
      <div className="flex">
        <Link to={`/settings`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar back={`/settings`} backText="Settings" title={brewery.name} button={cancelButton} />
        <RenderWithPermission permission={permissions.canUpdateBrewery}>
          <BreweryEdit />
        </RenderWithPermission>
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(BrewerySettingsPage));



// WEBPACK FOOTER //
// ./src/pages/brewery/brewery.jsx